define('shoptheme/components/layout/default',[
	"cartware/components/_base",
	"lodash",
	"jquery",
	"jquery-dotdotdot",
	"checked-polyfill",
	"jquery-lazyload",
	"magnific-popup"
], function(
	Component,
	_,
	$
) {
	return Component.create({
		$init: function() {
			$('input[type="checkbox"], input[type="radio"]').checkedPolyfill();

			this.patchMagnificPopup();
			this.textOverflowEllipsis();
			this.focusValidation();
		},

		patchMagnificPopup: function() {
			var proto = $.magnificPopup.proto,
				open = proto.open,
				close = proto.close,
				$body = $(document.body);

			proto.open = function() {
				var res = open.apply(this, arguments);

				$body.addClass("modal-open");

				return res;
			};

			proto.close = function() {
				var res = close.apply(this, arguments);

				$body.removeClass("modal-open");

				return res;
			};
		},

		textOverflowEllipsis: function() {
			var ellipsisElements = $('.ellipsis');
			ellipsisElements.dotdotdot();
			$(window).resize($.throttle(10, function() { ellipsisElements.dotdotdot(); }));
		},

		focusValidation: function() {
			Validation.prototype.validate = _.wrap(Validation.prototype.validate, function(orig) {
				var result = orig.apply(this, arguments),
					form = this.form;
				
				if (!result) {
					_.delay(function() {
						var $window = $(window),
							windowHeight = $window.height(),
							scrollTop = $window.scrollTop(),
							advices = $(".validation-advice:visible", form),
							adviseVisible;

						adviseVisible = advices.length === 0 || _.any(advices.get(), function(el) {
							var $el = $(el),
								position = $el.offset();

							return position.top + $el.height() >= scrollTop && position.top <= scrollTop + windowHeight;
						});

						if (!adviseVisible) {
							$window.scrollTop(advices.offset().top - 100);
						}
					}, 10);
				}

				return result;
			});
		}
	});
});
